module.exports = __webpack_public_path__ + "img/oddnary-sunset-orange-scheme.ec95b8e2.jpg";